import React, { lazy, useContext, useEffect, useState, Suspense } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import PatientComplaints from "../../Complaints";
import PatientAllergy from "../../Allergy";
import PhysicalExamination from "../../PhysicalExamination";
import History from "../../History/History";
import PatientPrescription from "../../Prescription";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import SaveIcon from "@mui/icons-material/Save";
import ButtonContainer from "../ButtonContainer";
import PatientManagementPlan from "../../ManagementPlan";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  deletePackageToUser,
  setPackageToUser,
  submitEmrService,
} from "../../../services";
import { useNavigate, useParams } from "react-router-dom";
import usePopup from "../../../../hooks/usePopup";
import VitalsTable from "../VitalsTable";
import ViewDetails from "../../ViewDetails/ViewDetails";
import { HL7ContexTriggerContex } from "../../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
// import DentalProcedure from "../DentalProcedures";
const DentalProcedure = lazy(() => import("../../DentalProcedures/indexv2"));
import useAuthentication from "../../../../hooks/useAuthentication";
import { assetsUrl, base } from "../../../../constants";
import { EmrContext } from "../../..";
import moduleRoutes from "../../../../routes/moduleRouteList";
import PageRouterList from "../../../../routes/routeList";
import HistoryComponent from "../HistoryComponent";
import BillingHistoryButton from "./BillingHistoryButton";
import {
  PackageTableDataType,
  SearchParamsType,
} from "../../../../Masters/TemplateMaster/PackageMaster/types";
import { getPackages } from "../../../../Masters/TemplateMaster/PackageMaster/services";
// import ActivityComponent from "../Activity";
const checkdental = {
  dental: true,
  dentistry: true,
  preventivedentistry: true,
  orthodontics: true,
  periodontics: true,
  endodontics: true,
  prosthodontics: true,
  gingivitis: true,
  periodontitis: true,
  admin: true
};
const ActivityComponent = lazy(() => import("../../Activity"));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function EmrContainerV2() {
  const authentiction = useAuthentication();
  const isDental = Boolean(
    checkdental[
    authentiction.user?.groupName
      ?.replace(/\s/g, "")
      .toLowerCase() as keyof typeof checkdental
    ]
  );
  const queryClient = useQueryClient()
  const tabStoreKey = "tabstoragekey";
  const pateintStorageKey = "patientId";
  const { patientId, encounterId } = useParams();
  const { patientData, dataLoading, refetcPatientData } = useContext(EmrContext);
  const navigateTo = useNavigate();
  const { CustomModal, showSnackbar } = usePopup();
  const [open, setOpen] = useState<boolean>(false);
  const [openVitals, setOpenVitals] = useState<boolean>(false);
  const [openPackageConfirm, setOpenPackageConfirm] = useState<boolean>(false);
  const [selectedPackage, setSelectedPackage] =
    useState<PackageTableDataType | null>(null);
  const [value, setValue] = useState(0);
  const { triggerApi } = useContext(HL7ContexTriggerContex);
  const [
    searchParams,
    //  setSearchParams
  ] = useState<SearchParamsType>({
    pageNumber: 0,
    pageSize: 25,
    filter: {
      searchText: "",
      status: 1,
    },
    sortField: "",
    sortOrder: "",
    clinicId: Number(authentiction?.user?.clinicId),
  });
  // const { mutate: checkDiagno, isLoading: checkDiagLoading } = useMutation(
  //   checkDiagnosis,
  //   {
  //     onSuccess: (result) => {
  //       if (result.response?.toLowerCase() == "nodata") {
  //         setOpen(true);
  //       } else {
  //         updateLog();
  //       }
  //     },
  //   }
  // );

  // const { mutate: updateLog, isLoading: updateLogLoading } = useMutation(
  //   updateUserLogHistory,
  //   {
  //     onSuccess: (result) => {
  //       console.log(result.response);
  //       if (
  //         result?.response?.toLowerCase() == "success" ||
  //         result?.response?.toLowerCase() == "updated" ||
  //         result?.response == "" ||
  //         result?.response == null
  //       ) {
  //         updateStatus(encounterId as string);
  //       } else {
  //         showSnackbar({
  //           message: "Failed !",
  //           open: true,
  //           variant: "warning",
  //           duration: 2000,
  //         });
  //       }
  //     },
  //     onError: () => {
  //       showSnackbar({
  //         message: "Something went wrong",
  //         open: true,
  //         variant: "warning",
  //         duration: 2000,
  //       });
  //     },
  //   }
  // );
  // const { mutate: updateStatus, isLoading: updateLoading } = useMutation(
  //   updateRegistrationStatus,
  //   {
  //     onSuccess: (result) => {
  //       if (
  //         result?.response?.toLowerCase() == "success" ||
  //         result?.response?.toLowerCase() == "updated" ||
  //         result?.response == "" ||
  //         result?.response == null
  //       ) {
  //         showSnackbar({
  //           message: "EMR saved",
  //           open: true,
  //           variant: "success",
  //           duration: 2000,
  //         });

  //         navigateTo(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.emrList}`);
  //       } else {
  //         showSnackbar({
  //           message: "Failed !",
  //           open: true,
  //           variant: "warning",
  //           duration: 2000,
  //         });
  //       }
  //     },
  //     onError: () => {
  //       showSnackbar({
  //         message: "Something went wrong",
  //         open: true,
  //         variant: "warning",
  //         duration: 2000,
  //       });
  //     },
  //   }
  // );

  const { data: pakages, isLoading: packagesLoading } = useQuery(
    [`inemrmasterlist`, searchParams],
    async () => getPackages(searchParams),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { mutate: setPackage, isLoading: packageFetching } = useMutation(
    setPackageToUser,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setOpenPackageConfirm(false);
          refetcPatientData()
          queryClient.invalidateQueries(["fetchLabList"]);
          queryClient.invalidateQueries(["fetchRadiologyList"]);
          queryClient.invalidateQueries(["patientProcedureList"]);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );

  const { mutate: deletePackage, isLoading: packageDeleting } = useMutation(
    deletePackageToUser,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          setOpenPackageConfirm(false);
          refetcPatientData()
          queryClient.invalidateQueries(["fetchLabList"]);
          queryClient.invalidateQueries(["fetchRadiologyList"]);
          queryClient.invalidateQueries(["patientProcedureList"]);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 2000,
        });
      },
    }
  );

  const handleSubmitEmr = () => {
    triggerApi();
    submitEmr({
      clinicId: authentiction.user?.clinicId as number,
      userId: authentiction.user?.login_id as number,
      encounterId: Number(encounterId),
      status: 1,
      destination:"Emr Submitted"
    });
  };

  const { mutate: submitEmr, isLoading: emrSubmissionLoading } = useMutation(
    submitEmrService,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 2000,
          });
          navigateTo(
            `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${PageRouterList.emrList}`
          );
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: (error: any) => {
        showSnackbar({
          message:
            error?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 5000,
        });
      },
    }
  );

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    localStorage.setItem(tabStoreKey, `${newValue}`);
    setValue(newValue);
    triggerApi();
  };

  const handleViewVitals = () => {
    setOpenVitals(true);
  };

  const handleInitialTabChange = () => {
    const patient = localStorage.getItem(pateintStorageKey);
    if (patient == patientId) {
      const tabValue = parseInt(localStorage.getItem(tabStoreKey) || "0");
      setValue(tabValue);
    } else {
      localStorage.setItem(pateintStorageKey, patientId as string);
    }
  };

  const handleConfirmPackage = () => {
    console.log("selectedPackage = ", selectedPackage)
    if (Boolean(selectedPackage)) {
      setPackage({
        clinicId: Number(authentiction.user?.clinicId),
        createdById: Number(authentiction.user?.userId),
        encounterId: Number(encounterId),
        packageId: selectedPackage?.packageId
          ? Number(selectedPackage?.packageId)
          : Number(patientData?.encounter?.packageId),
      });
    } else {
      deletePackage({
        clinicId: Number(authentiction.user?.clinicId),
        createdById: Number(authentiction.user?.userId),
        encounterId: Number(encounterId),
        packageId: Number(patientData?.encounter?.packageId),
      });
    }
  };

  const handleClosePackage = () => {
    setOpenPackageConfirm(false);
    setSelectedPackage(
      patientData?.encounter?.packageId
        ? {
          packageId: Number(patientData?.encounter?.packageId || 0),
          packageName: String(patientData?.encounter?.packageName || ""),
          packageCode: String(patientData?.encounter?.packageCode || ""),
          packageDescription: "",
          clinicId: Number(authentiction?.user?.clinicId),
          packageStatus: 1,
          packageActualRate: Number(
            patientData?.encounter?.packageActualRate || 0
          ),
          packageDiscount: Number(0),
          packageFinalRate: Number(
            patientData?.encounter?.packageFinalRate || 0
          ),
          isLabPackage: Number(patientData?.encounter?.packageFinalRate || 0),
          packageCreatedDate: "",
        }
        : null
    );
  };
  const { user } = useAuthentication()
  const isQatarRegion = user?.region === "QATAR_REGION";

  const Riayati = () => {
    const body = {
      clinician_id: patientData?.encounter?.liscenceNo || "",
      emrNo: patientData?.pmaster?.patientId || "",
      Name: patientData?.encounter?.doctorName || "",
      clinicName: patientData?.encounter?.clinicName || "",
      facilityLicenseNo: patientData?.encounter?.facilityLicenseNo || "",
    };
    var httpurl = `${(window as any)._env_?.CLINIC_VIEWR_URL}/submitSSO?MRN=${body.emrNo}&AssigningAuthority=${body.facilityLicenseNo}&ClinicianID=${body.clinician_id}&Role=physician&Name=${body.Name}`;
    // var httpurl =`http://3.28.231.227:6060/RiayatiPublicSSO.aspx?MRN=${body.emrNo}&AssigningAuthority=PHHIS&ClinicianID=${body.clinician_id}5&Role=physician`;
    window.open(httpurl, "_blank");
  };

  useEffect(() => {
    handleInitialTabChange();
  }, []);

  useEffect(() => {
    if (patientData?.encounter?.packageId) {
      setSelectedPackage({
        packageId: Number(patientData?.encounter?.packageId || 0),
        packageName: String(patientData?.encounter?.packageName || ""),
        packageCode: String(patientData?.encounter?.packageCode || ""),
        packageDescription: "",
        clinicId: Number(authentiction?.user?.clinicId),
        packageStatus: 1,
        packageActualRate: Number(
          patientData?.encounter?.packageActualRate || 0
        ),
        packageDiscount: Number(0),
        packageFinalRate: Number(patientData?.encounter?.packageFinalRate || 0),
        isLabPackage: Number(patientData?.encounter?.packageFinalRate || 0),
        packageCreatedDate: "",
      } as PackageTableDataType);
    }
  }, [patientData?.encounter?.packageId]);


  console.log("patientData = ", pakages)
  return (
    <div className="pt-3 relative">
      <CustomModal
        open={open}
        setOpen={setOpen}
        title="Please add Diagnosis Details?"
      >
        <div className="">
          <div className="w-[40vw] p-3">
            You have not added diagnosis principal details, please add one and
            click submit EMR Button?
          </div>
          <div className="p-2 flex flex-row gap-3 justify-end">
            <Button
              variant="text"
              onClick={() => {
                setOpen(false);
              }}
            >
              no
            </Button>
            <Button
              variant="text"
              onClick={() => {
                setValue(5);
                setOpen(false);
              }}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={openVitals}
        setOpen={setOpenVitals}
        title="Patient vitals"
      >
        <div className="">
          <div className="w-[50vw] h-[h-60dvh] p-3">
            <div className="flex justify-end col-span-2">
              <HistoryComponent title="Vitals" tableprops={vitalsTableProps} />
            </div>
            <VitalsTable />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={openPackageConfirm}
        setOpen={setOpenPackageConfirm}
        handleClose={handleClosePackage}
        title="Package"
      >
        <div className="w-[40vw]">
          <div className="p-4">
            <Typography className="text-lg font-semibold">
              Would you like to {selectedPackage?.packageName ? "select" : "delete"} the package {" "}
              <span className="text-blue-500 font-bold">
                {selectedPackage?.packageName}
              </span>
              ?
            </Typography>
          </div>
          <div className="flex justify-end gap-3 px-4 py-2">
            <Button
              disabled={packageFetching || packageDeleting}
              color="error"
              onClick={handleClosePackage}
            >
              no
            </Button>
            <Button
              disabled={packageFetching || packageDeleting}
              endIcon={packageFetching || packageDeleting && <CircularProgress size={18} />}
              color="success"
              onClick={handleConfirmPackage}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>

      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.background.paper,
        })}
        className="absolute top-0 left-4 w-[130px] px-3 rounded"
      >
        EMR details
      </Box>
      <Paper className="h-fit">
        <div className="w-full flex justify-end items-center p-2 gap-2 border-b">
          {Boolean(isDental || String(patientData?.encounter?.departmentName).toLowerCase() == "dental") ? null : <Autocomplete<PackageTableDataType | null, boolean, boolean>
            options={pakages?.response?.packageDto || []}
            value={selectedPackage}
            disabled={packageFetching || packageDeleting || packagesLoading}
            loading={packagesLoading || packageDeleting || dataLoading}
            sx={{ width: "30%" }}
            renderInput={(params) => (
              <TextField {...params} label="Select package" />
            )}
            disableClearable={false}
            getOptionLabel={(option) =>
              `${option?.packageName}  [Package rate: ${option?.packageFinalRate} | Rate: ${option?.packageActualRate}]`
            }
            // isOptionEqualToValue={(option, value) =>
            //   option.packageId == value.packageId
            // }
            renderOption={(props, option, { selected }) => (
              <ListItem
                {...props}
                disablePadding
                className="border-b cursor-pointer"
              >
                <ListItemIcon>
                  <Checkbox checked={selected} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <div className="grid grid-cols-7 items-center">
                      <Typography color={"primary"} className="col-span-4">
                        {option?.packageName}{" "}
                        {Boolean(option?.isLabPackage) && (
                          <Chip size="small" color="warning" label="Lab" />
                        )}
                      </Typography>
                      <div className="col-span-3 px-2">
                        <div className="grid grid-cols-8 items-center">
                          <Typography className="col-span-4" fontSize={".7rem"}>
                            Package rate
                          </Typography>
                          <Typography className="col-span-4" fontSize={".7rem"}>
                            : {option?.packageFinalRate}
                          </Typography>
                        </div>
                        <div className="grid grid-cols-8 items-center space-y-2">
                          <Typography className="col-span-4" fontSize={".7rem"}>
                            Actual rate
                          </Typography>
                          <Typography className="col-span-4" fontSize={".7rem"}>
                            : {option?.packageActualRate}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  }
                />
              </ListItem>
            )}
            onChange={(_, value) => {
              setSelectedPackage(value as PackageTableDataType);
              setOpenPackageConfirm(true);
            }}
          />}
          {!isQatarRegion && (
            <Tooltip title="Riayati Clinical Viewer">
              <Box
                onClick={Riayati}
                role="button"
                sx={{ ...riyatiLogoStyle, "&:hover": riyatiLogoHover }}
              />
            </Tooltip>
          )}

          <Button onClick={handleViewVitals} endIcon={<RemoveRedEyeIcon />}>
            View Vitals
          </Button>
          <ViewDetails />
          <BillingHistoryButton />
          <Button
            color="success"
            disabled={emrSubmissionLoading}
            endIcon={
              emrSubmissionLoading ? (
                <CircularProgress
                  size={18}
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                />
              ) : (
                <SaveIcon />
              )
            }
            onClick={handleSubmitEmr}
          >
            submit emr
          </Button>
          {<ButtonContainer />}
        </div>

        <div className="w-full flex justify-center border-b">
          <Box
            sx={{
              maxWidth: "80vw",
              bgcolor: "background.paper",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
            >
              <Tab label="History" {...a11yProps(0)} />
              <Tab label="Complaints" {...a11yProps(1)} />
              <Tab label="Allergy" {...a11yProps(2)} />
              <Tab label="Physical examination" {...a11yProps(3)} />
              <Tab label="Activity" {...a11yProps(4)}></Tab>
              <Tab label="MGNT Plan" {...a11yProps(5)} />
              <Tab label="Prescription" {...a11yProps(6)}></Tab>
              <Tab label="Dental Procedure" {...a11yProps(7)} />
            </Tabs>
          </Box>
        </div>
        <div className="h-fit min-h-[49dvh] mb-3">
          <CustomTabPanel value={value} index={0}>
            <History />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <PatientComplaints />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <PatientAllergy />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <PhysicalExamination />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <Suspense fallback={<CircularProgress size={4} />}>
              <ActivityComponent />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={6}>
            <PatientPrescription />
          </CustomTabPanel>

          <CustomTabPanel value={value} index={7}>
            <Suspense fallback={<CircularProgress size={20} />}>
              <DentalProcedure />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={5}>
            <PatientManagementPlan />
          </CustomTabPanel>
        </div>
      </Paper>
    </div>
  );
}

export default EmrContainerV2;

const riyatiLogoStyle = {
  backgroundImage: `url("${assetsUrl}/logos/riayati-logo.png")`,
  width: "100px",
  height: "40px",
  backgroundPosition: "center",
  backgroundSize: "80px",
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
};

const riyatiLogoHover = {
  backgroundImage: `url("${assetsUrl}/logos/riayati-logo.png")`,
  backgroundColor: "#dbdbdb",
  width: "100px",
  height: "40px",
  backgroundPosition: "center",
  backgroundSize: "80px",
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
};

const vitalsTableProps = [
  {
    heading: "Height",
    key: "height",
  },
  {
    heading: "Weight",
    key: "weight",
  },
  {
    heading: "Temperature",
    key: "temperature",
  },
  {
    heading: "bmi",
    key: "bmi",
  },
  {
    heading: "BSA",
    key: "bsa",
  },
  {
    heading: "Blood Group",
    key: "bloodGroup",
  },
  {
    heading: "Systolic BP",
    key: "systolicBP",
  },
  {
    heading: "Diastolic BP",
    key: "diastolicBP",
  },
  {
    heading: "Sugar",
    key: "sugar",
  },
  {
    heading: "Pulse/Heart Rate",
    key: "heartRate",
  },
  {
    heading: "SPO2",
    key: "spo2",
  },
  {
    heading: "Respiratory",
    key: "respiratory",
  },
  {
    heading: "Head Circumference",
    key: "headCircumference",
  },
  {
    heading: "Pain Scale",
    key: "painscale",
  },
  {
    heading: "Immunisation History",
    key: "immunisationHistory",
  },
];
